import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface SnackbarConfig {
  message: string;
  icon?: string;
  duration?: number;
}

@Injectable({
  providedIn: 'root'
})
export class SnackbarService {
  private snackbarSubject = new Subject<SnackbarConfig>();
  snackbar$ = this.snackbarSubject.asObservable();

  open(message: string, icon?: string, duration: number = 6000) {
    this.snackbarSubject.next({ message, icon, duration });
  }
}
